export class AwsWorkspaceInfo {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "accountId",
            "baseName": "accountId",
            "type": "string",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return AwsWorkspaceInfo.attributeTypeMap;
    }
    constructor() {
    }
}
